import { ScenarioScene } from "@/lib/utils/lomdaV3/types";

/** Resolve where a choice leads: explicit scene, end, or the next scene in order. */
export function resolveNextSceneId(
    scenes: ScenarioScene[],
    currentId: string,
    nextSceneId: string
): string | null {
    if (nextSceneId === "end") return null;
    if (nextSceneId && scenes.some((s) => s.id === nextSceneId))
        return nextSceneId;
    const index = scenes.findIndex((s) => s.id === currentId);
    if (index === -1) return null;
    return scenes[index + 1]?.id ?? null;
}
